<script setup>
import {defineModel, defineProps} from 'vue'

const modelValue = defineModel({required: true})

const props = defineProps({
  options: {
    type: Array,
    required: true,
    validator: opts => opts.every(o => o && 'label' in o && 'value' in o),
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  id: {
    type: String,
    default: 'btn-group',
  },
  ariaLabel: {
    type: String,
    default: '',
  },
})
</script>

<template>
  <div class="btn-group btn-row-group" role="group" :aria-label="props.ariaLabel">
    <button
      v-for="option in props.options"
      :key="`${props.id}-${option.value}`"
      type="button"
      :class="['btn btn-secondary text-capitalize', {active: modelValue === option.value}]"
      :disabled="props.disabled || option.disabled"
      @click="modelValue = option.value"
    >
      {{ option.label }}
    </button>
  </div>
</template>
